import { DateHelper } from "shared/helpers/DateHelper";
import itemSizes from "constants/sizes";

export function calculateHeightsAndTimes(calendarItems, options = {}) {
  const dueItems = options.dueItems || [];
  const { dateHelper } = options;
  const hsats = [];

  function lastItemHeight() {
    if (hsats.length === 0) return 0;
    const lastItem = hsats[hsats.length - 1];
    return lastItem.height;
  }

  function initialheight() {
    return (
      dueItems.length * parseFloat(itemSizes.normalItemHeight) +
      parseFloat(itemSizes.smallHeadingHeight) +
      parseFloat(itemSizes.itemVerticalMarginLarger)
    );
  }

  function itemHeight(type) {
    const result = {
      day_name: parseFloat(itemSizes.smallHeadingHeight),
      continuing_calendar_note: parseFloat(
        itemSizes.smallHeadingHeight
      ),
      calendar_note: parseFloat(itemSizes.normalItemHeight),
      task: parseFloat(itemSizes.normalItemHeight),
      new_task: parseFloat(itemSizes.normalItemHeight),
      appointment: parseFloat(itemSizes.normalItemHeight),
    }[type];
    return result + parseFloat(itemSizes.itemVerticalMargin);
  }

  function render(item) {
    return {
      height: lastItemHeight() + itemHeight(item.type),
      day: DateHelper.parseDate(item.day),
    };
  }
  if (dateHelper) {
    hsats.push({ height: initialheight(), day: dateHelper.date });
  }
  calendarItems.forEach((item) => {
    hsats.push(render(item));
  });
  return hsats;
}

export function insertionIndex(cursorIndex, planItems) {
  let i = 0;
  let nextItem = null;
  while (true) {
    nextItem = planItems[cursorIndex + i];
    if (nextItem === undefined) {
      return planItems.length - 1;
    }
    if (
      nextItem.type !== "calendar_note" &&
      nextItem.type !== "continuing_calendar_note"
    ) {
      return cursorIndex + i;
    }
    i++;
  }
}

export function getInitialIndex(doneItems) {
  for (let i = doneItems.length - 1; i >= 0; i--) {
    if (doneItems[i].day_name === "Today") {
      return i;
    }
  }
}
